/** SDK lifecycle events the host can subscribe to. */
export type CrEvent = 'open' | 'close' | 'unreadchange';

export type Handler = (payload?: unknown) => void;

/** Tiny synchronous event emitter. Listener exceptions are isolated so one bad handler can't break others. */
export class Emitter {
  #listeners = new Map<string, Set<Handler>>();

  on(event: string, fn: Handler): void {
    let set = this.#listeners.get(event);
    if (!set) {
      set = new Set();
      this.#listeners.set(event, set);
    }
    set.add(fn);
  }

  off(event: string, fn: Handler): void {
    this.#listeners.get(event)?.delete(fn);
  }

  emit(event: string, payload?: unknown): void {
    const set = this.#listeners.get(event);
    if (!set) return;
    for (const fn of [...set]) {
      try {
        fn(payload);
      } catch (err) {
        console.error('[clickrelease] event listener threw', err);
      }
    }
  }

  clear(): void {
    this.#listeners.clear();
  }
}
